import { css } from '@/styled-system/css';

export const popoverCloseButtonStyles = css.raw({
  position: 'absolute',
  insetBlockStart: 'tighter',
  insetInlineEnd: 'tighter',
  zIndex: 100,
});
